import { Command } from '@/app/common/base/command'

export class SubmitOcktoTestDataCommand extends Command {
    public async run(testCase: string, productActionId: string) {
        await this.client.post(`/api/inventory-form/ockto-debug/${productActionId}`, { testCase })
    }
}
